import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import useFetch from 'use-http';
import { useForm } from 'react-hook-form';
import Project from 'src/models/Project';
import OwnerUtil from 'src/util/OwnerUtil';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import State from 'src/models/State';
import PagedResultSet from 'src/models/common/PagedResultSet';
import * as Constants from 'src/components/common/Constants';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IManageDefaultLesseeProps {
    states: PagedResultSet<State>;
}

const ManageDefaultLessee = (props: IManageDefaultLesseeProps) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const [defaultOwner, setDefaultOwner] = useState(undefined);
    const { register, handleSubmit, reset } = useForm();
    const { get, put, post, response } = useFetch();

    const loadData = async () => {
        const project = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}`);
        if (response.ok && project) {
            let owner = await get(
                `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/${(project as Project).defaultOwnerLookUpId}`
            );
            if (response.ok && owner) {
                owner = OwnerUtil.MapOwner(owner);
                setDefaultOwner(owner);
                reset(owner);
                console.log(owner);
            }
        }
    };

    useEffect(() => {
        loadData();
    }, [reset]);

    // Options for the state dropdown selection
    const stateDropdownOptions = () => {
        return props.states
            ? props.states?.items?.map((st: State) => {
                    return { value: st.id, label: st.name };
                })
            : [];
    };    

    const onSubmit = async (data: OwnerBusiness) => {
        console.log('data', data);
        data.id = parseInt(data?.id + '', 10) || 0;
        data.address.id = parseInt(data?.address?.id + '', 10) || 0;
        data.address.stateId = parseInt(data?.address.stateId + '', 10) || null;
        data.addressId = parseInt(data?.address?.id + '', 10) || 0;
        data.ownerType = 'Business';
        data.contactPersonDetailsId = parseInt(data?.contactPersonDetailsId + '', 10) || 0;
        data.containerOwnerId = parseInt(data?.containerOwnerId + '', 10) || 0;
        data.ownerLookUpId = parseInt(data?.ownerLookUpId + '', 10) || 0;

        if (data?.id > 0 && data?.contactPersonDetailsId > 0 && data?.containerOwnerId > 0 && data.ownerLookUpId > 0) {
            await put(
                `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/${data.id}/edit/owner-business`,
                data
            );
        } else {
            var result = await post(
                `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/business`,
                data
            );

            if (response.ok) {
                updateDefaultOwner(result);
            }
        }
    };

    const updateDefaultOwner = (ownerLookupId: number) => {
        put(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/default-owner/${ownerLookupId}`);
    };

    return (
        <div>
            {defaultOwner && (
                <>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div style={{ display: 'none' }}>
                            <RHFInputBox name="id" label="" register={register} disabled={true} />
                            <RHFInputBox name="ownerLookUpId" label="" register={register} disabled={true} />
                            <RHFInputBox name="contactPersonDetailsId" label="" register={register} disabled={true} />
                            <RHFInputBox name="containerOwnerId" label="" register={register} disabled={true} />
                            <RHFInputBox name="address.id" label="" register={register} disabled={true} />
                        </div>
                        <FormRow style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2.75rem' }}>
                            <RHFInputBox 
                                name="name" 
                                label="Owner Name" 
                                register={register}
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }}
                                bodyStyle={{ width: '35%' }}
                            />

                            <RHFInputBox 
                                name="contactPersonFirstName" 
                                label="First Name" 
                                register={register} 
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }} 
                                bodyStyle={{ width: '30%' }}
                            />

                            <RHFInputBox 
                                name="contactPersonLastName" 
                                label="Last Name" 
                                register={register} 
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }} 
                                bodyStyle={{ width: '30%' }}
                            />
                        </FormRow>
                        <FormRow style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2.75rem' }}>
                            <RHFInputBox 
                                name="address.addressLine1" 
                                label="Address Line 1" 
                                register={register} 
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }}
                            />
                        </FormRow>
                        <FormRow style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2.75rem' }}>
                            <RHFInputBox 
                                name="address.addressLine2" 
                                label="Address Line 2" 
                                register={register} 
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }}
                            />
                        </FormRow>
                        <FormRow style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2.75rem' }}>
                            <RHFInputBox 
                                name="address.city" 
                                label="City" 
                                register={register} 
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }}
                                bodyStyle={{ width: '40%' }} 
                            />

                            <RHFSelect
                                name="address.stateId"
                                label="State"
                                options={stateDropdownOptions()}
                                register={register}
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }}
                                bodyStyle={{ width: '15%' }} 
                            />

                            <RHFInputBox 
                                name="address.zipCode" 
                                label="Zip Code" 
                                register={register} 
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}} 
                                style={{marginLeft: '3px', whiteSpace: 'nowrap', verticalAlign: 'middle', width: '100%' }}
                                bodyStyle={{ width: '15%' }} 
                            />
                        </FormRow>

                        <br />
                        <div style={{ marginTop: '1rem', display: 'flex', gap: '3rem' }}>
                            <Button type="submit" intent="primary" text={Constants.DefaultLesseePageFormSubmitText} />
                        </div>
                    </form>
                </>
            )}
        </div>
    );
};

export default ManageDefaultLessee;



// WEBPACK FOOTER //
// ./src/components/project/sections/ManageDefaultLessee.tsx